import template from './resident-portal.html';
import { selectors } from '../../../state';
import { ITEM_KINDS, ITEM_DEFINITION_CODES } from '../../../constants';
import './resident-portal.global.css';
import { trackEngagement } from '@mover-app/engagement';

class ResidentPortalController {
  constructor(updStore) {
    'ngInject';
    Object.assign(this, { updStore });
  }

  $onInit() {
    this.disconnect = this.updStore.connect(mapStateToThis)(this);
    trackEngagement({
      name: 'Resident Portal',
      code: ITEM_DEFINITION_CODES.RESIDENT_PORTAL,
    });
  }

  $onDestroy() {
    this.disconnect();
  }
}
export const ResidentPortalComponent = {
  template,
  controller: ResidentPortalController,
};

function mapStateToThis(state) {
  const itemDefinition = selectors.itemDefinition.byCode(
    ITEM_KINDS.RESIDENT_PORTAL
  );
  const residentPortal = itemDefinition.residentPortal(state);

  return {
    buttonLink: residentPortal.button_link,
    buttonText: residentPortal.button_text,
    subText: residentPortal.sub_text,
    clientName: selectors.current.siteConfig().channelClientName(state),
  };
}
